import { render, staticRenderFns } from "./FormPost.vue?vue&type=template&id=6670bf82&"
import script from "./FormPost.vue?vue&type=script&lang=js&"
export * from "./FormPost.vue?vue&type=script&lang=js&"
import style0 from "./FormPost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports